/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateMerchantCredentialDto } from '../models/CreateMerchantCredentialDto';
import type { CreateMerchantCredentialEntity } from '../models/CreateMerchantCredentialEntity';
import type { ListMerchantCredentialEntity } from '../models/ListMerchantCredentialEntity';
import type { MerchantCredentialResponseEntity } from '../models/MerchantCredentialResponseEntity';
import type { UpdateMerchantCredentialDto } from '../models/UpdateMerchantCredentialDto';
import type { UpdateMerchantCredentialStatusDto } from '../models/UpdateMerchantCredentialStatusDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MerchantApiCredentialsService {
  /**
   * Tạo credential Merchant API
   * @param requestBody
   * @returns CreateMerchantCredentialEntity
   * @throws ApiError
   */
  public static merchantApiControllerCreateClient(
    requestBody: CreateMerchantCredentialDto,
  ): CancelablePromise<CreateMerchantCredentialEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/merchant-api/clients',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Request không hợp lệ.`,
        401: `Xác thực Merchant API thất bại.`,
        403: `Credential không được phép gọi thao tác.`,
        404: `Không tìm thấy tài nguyên.`,
        409: `Request xung đột với trạng thái hiện tại.`,
        500: `Lỗi hệ thống.`,
      },
    });
  }

  /**
   * Danh sách credential Merchant API
   * @param companyId Lọc thông tin xác thực theo mã công ty sở hữu.
   * @param status Lọc thông tin xác thực theo trạng thái vòng đời.
   * @param search Tìm kiếm theo tên công ty sở hữu, tên/mã số thuế/Connect ID công ty tích hợp, tên client, Client ID hoặc mã công ty.
   * @param page Số trang, bắt đầu từ 1.
   * @param limit Số bản ghi trên mỗi trang, từ 1 đến 100.
   * @returns ListMerchantCredentialEntity
   * @throws ApiError
   */
  public static merchantApiControllerListClients(
    companyId?: string,
    status?: 'ACTIVE' | 'INACTIVE',
    search?: string,
    page?: number,
    limit?: number,
  ): CancelablePromise<ListMerchantCredentialEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/merchant-api/clients',
      query: {
        companyId: companyId,
        status: status,
        search: search,
        page: page,
        limit: limit,
      },
      errors: {
        400: `Request không hợp lệ.`,
        401: `Xác thực Merchant API thất bại.`,
        403: `Credential không được phép gọi thao tác.`,
        404: `Không tìm thấy tài nguyên.`,
        409: `Request xung đột với trạng thái hiện tại.`,
        500: `Lỗi hệ thống.`,
      },
    });
  }

  /**
   * Chi tiết credential Merchant API
   * @param id
   * @returns MerchantCredentialResponseEntity
   * @throws ApiError
   */
  public static merchantApiControllerGetClientDetail(
    id: string,
  ): CancelablePromise<MerchantCredentialResponseEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/merchant-api/clients/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Request không hợp lệ.`,
        401: `Xác thực Merchant API thất bại.`,
        403: `Credential không được phép gọi thao tác.`,
        404: `Không tìm thấy tài nguyên.`,
        409: `Request xung đột với trạng thái hiện tại.`,
        500: `Lỗi hệ thống.`,
      },
    });
  }

  /**
   * Cập nhật credential Merchant API
   * @param id
   * @param requestBody
   * @returns MerchantCredentialResponseEntity
   * @throws ApiError
   */
  public static merchantApiControllerUpdateClient(
    id: string,
    requestBody: UpdateMerchantCredentialDto,
  ): CancelablePromise<MerchantCredentialResponseEntity> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/merchant-api/clients/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Request không hợp lệ.`,
        401: `Xác thực Merchant API thất bại.`,
        403: `Credential không được phép gọi thao tác.`,
        404: `Không tìm thấy tài nguyên.`,
        409: `Request xung đột với trạng thái hiện tại.`,
        500: `Lỗi hệ thống.`,
      },
    });
  }

  /**
   * Xóa credential Merchant API
   * @param id
   * @returns MerchantCredentialResponseEntity
   * @throws ApiError
   */
  public static merchantApiControllerDeleteClient(
    id: string,
  ): CancelablePromise<MerchantCredentialResponseEntity> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/merchant-api/clients/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Request không hợp lệ.`,
        401: `Xác thực Merchant API thất bại.`,
        403: `Credential không được phép gọi thao tác.`,
        404: `Không tìm thấy tài nguyên.`,
        409: `Request xung đột với trạng thái hiện tại.`,
        500: `Lỗi hệ thống.`,
      },
    });
  }

  /**
   * Cập nhật trạng thái credential Merchant API
   * @param id
   * @param requestBody
   * @returns MerchantCredentialResponseEntity
   * @throws ApiError
   */
  public static merchantApiControllerUpdateClientStatus(
    id: string,
    requestBody: UpdateMerchantCredentialStatusDto,
  ): CancelablePromise<MerchantCredentialResponseEntity> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/merchant-api/clients/{id}/status',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Request không hợp lệ.`,
        401: `Xác thực Merchant API thất bại.`,
        403: `Credential không được phép gọi thao tác.`,
        404: `Không tìm thấy tài nguyên.`,
        409: `Request xung đột với trạng thái hiện tại.`,
        500: `Lỗi hệ thống.`,
      },
    });
  }
}
